import { apiClient as baseApiClient } from '#/api/client.tsx';
import type { EtcTicket } from '../model';

const cockpitApiClient = baseApiClient.create({
  baseURL: `${import.meta.env.VITE_BASE_URL}/cockpit/auto-pay`,
});

const ENROLLMENT_BASE = '/etc-auto-pay-enrollments';

type YYYYMMDD = string;
type ISODateTime = string;

type ScheduleEnrollmentsBody = {
  scheduledDate: YYYYMMDD;
};

export enum ScheduledStateEnum {
  SCHEDULED = 'SCHEDULED', // 已預約、尚未執行
  EXECUTED = 'EXECUTED', //  排程觸發後成功產生 ticket
  FAILED = 'FAILED', //  排程觸發但執行失敗
  CANCELLED = 'CANCELLED', //  已取消
}

type ScheduleEnrollmentsResponse = {
  id: string;
  etcAutoPayEnrollmentId: EtcTicket['etcAutoPayEnrollmentId'];
  scheduledDate: YYYYMMDD;
  state: ScheduledStateEnum;
  operator: string;
  executedTicketId: EtcTicket['id'];
  reason: string;
  createDateTime: ISODateTime;
  updateDateTime: ISODateTime;
};

export const scheduleEnrollments = (
  enrollmentId: EtcTicket['etcAutoPayEnrollmentId'],
  body: ScheduleEnrollmentsBody,
) => {
  return cockpitApiClient
    .post<{
      data: ScheduleEnrollmentsResponse;
    }>(`${ENROLLMENT_BASE}/${enrollmentId}/ticket-schedules`, body)
    .then((res) => res.data.data);
};

type DeleteScheduleResponse = {
  id: string;
  state: ScheduledStateEnum;
  reason: string;
  updateDateTime: ISODateTime;
};

export const deleteScheduledEnrollments = ({
  enrollmentId,
  scheduleId,
}: {
  enrollmentId: EtcTicket['etcAutoPayEnrollmentId'];
  scheduleId: string;
}) => {
  return cockpitApiClient
    .delete<{
      data: DeleteScheduleResponse;
    }>(`${ENROLLMENT_BASE}/${enrollmentId}/ticket-schedules/${scheduleId}`)
    .then((res) => res.data.data);
};
